(() => {
  const dialog = document.getElementById('customew-artwork-guide');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const selector = '.ymq-option-popup[data-ymqmodal-trigger]';
  let opener;
  const findTrigger = (target) => {
    const trigger = target instanceof Element ? target.closest(selector) : null;
    return trigger && trigger.textContent.trim().toUpperCase() === 'FILE REQUIREMENTS' ? trigger : null;
  };
  const markTriggers = () => {
    document.querySelectorAll(selector).forEach((trigger) => {
      if (!findTrigger(trigger) || trigger.hasAttribute('data-customew-artwork-trigger')) return;
      trigger.setAttribute('data-customew-artwork-trigger', '');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
    });
  };
  const open = (event, trigger) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    opener = trigger;
    document.documentElement.classList.add('customew-guide-open');
    dialog.showModal();
    dialog.querySelector('.customew-guide__body').scrollTop = 0;
    dialog.querySelector('#customew-guide-title').focus({ preventScroll: true });
  };
  window.addEventListener('click', (event) => {
    const trigger = findTrigger(event.target);
    if (trigger) open(event, trigger);
  }, true);
  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = findTrigger(event.target);
    if (trigger) open(event, trigger);
  }, true);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('customew-guide-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  markTriggers();
  const target = document.getElementById('AddToCartForm');
  if (!target) return;
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      markTriggers();
    });
  }).observe(target, { childList: true, subtree: true });
})();
